import React from "react";
import "./PageHeader.css";

export default function PageHeader({ activeCat, active, total, done, user, onLogout, onAdminClick, onChangePassword }) {
  const dateLabel = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <header className="header">
        <h2>
          {activeCat ? activeCat.name : <>All <em>Tasks</em></>}
        </h2>
        <div className="header-meta">
          <span>{dateLabel}</span>
          <span className="dot"/>
          <span>{active} remaining</span>
          {user && (
            <>
              <span className="dot"/>
              <span className="header-user">{user.email}</span>
              {user.is_admin && (
                <button className="header-admin" onClick={onAdminClick} title="Admin">Admin</button>
              )}
              <button className="header-logout" onClick={onChangePassword} title="Change password">⚙</button>
              <button className="header-logout" onClick={onLogout} title="Sign out">Sign out</button>
            </>
          )}
        </div>
      </header>

      <div className="stats">
        <div className="stat">
          <div className="stat-number">{total}</div>
          <div className="stat-label">Total</div>
        </div>
        <div className="stat">
          <div className="stat-number">{active}</div>
          <div className="stat-label">Active</div>
        </div>
        <div className="stat">
          <div className="stat-number">{done}</div>
          <div className="stat-label">Done</div>
        </div>
      </div>
    </>
  );
}
